import createIcon from '../../createIcon';

/**
 * @component @name PinEnd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTJWNkg0VjE4SDE0VjIwSDRDMi45IDIwIDIgMTkuMSAyIDE4VjZDMiA0LjkgMi45IDQgNCA0SDIwQzIxLjEgNCAyMiA0LjkgMjIgNlYxMkgyMFpNMTkgMTRDMTcuMzQgMTQgMTYgMTUuMzQgMTYgMTdDMTYgMTguNjYgMTcuMzQgMjAgMTkgMjBDMjAuNjYgMjAgMjIgMTguNjYgMjIgMTdDMjIgMTUuMzQgMjAuNjYgMTQgMTkgMTRaTTE0LjY2IDhIOVYxMy42NkwxMS4xMiAxMS41NEwxMy45NSAxNC4zN0wxNS4zNiAxMi45NkwxMi41MyAxMC4xM0wxNC42NiA4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PinEnd = createIcon('PinEnd', [
  [
    'path',
    {
      d: 'M20 12V6H4V18H14V20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H20C21.1 4 22 4.9 22 6V12H20ZM19 14C17.34 14 16 15.34 16 17C16 18.66 17.34 20 19 20C20.66 20 22 18.66 22 17C22 15.34 20.66 14 19 14ZM14.66 8H9V13.66L11.12 11.54L13.95 14.37L15.36 12.96L12.53 10.13L14.66 8Z',
      key: 'p2un56',
    },
  ],
]);

export default PinEnd;
